import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';

const Barchart = ({ data, color, fadeColor, gradientID }) => (
  
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 30, right: 30, left: 0, bottom: 10 }}>
        <defs>
          <linearGradient id={gradientID} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={1} />
            <stop offset="100%" stopColor={fadeColor} stopOpacity={1} />
            
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="smell" />
        <YAxis />
        <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: 8 }} />
        <Legend verticalAlign="top" height={36} />
        <Bar dataKey="count" fill={`url(#${gradientID})`} radius={[8, 8, 0, 0]} isAnimationActive={true} label={{ position: 'top', fill: '#333' }} />
      </BarChart>
    </ResponsiveContainer>
  
);

export default Barchart;
